import { render, staticRenderFns } from "./financeSymbol.vue?vue&type=template&id=67062a3a&scoped=true"
import script from "./financeSymbol.vue?vue&type=script&lang=js"
export * from "./financeSymbol.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67062a3a",
  null
  
)

export default component.exports